/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReplaceHomeHealthPractitionerAssignmentRole } from './ReplaceHomeHealthPractitionerAssignmentRole';
import {
    ReplaceHomeHealthPractitionerAssignmentRoleFromJSON,
    ReplaceHomeHealthPractitionerAssignmentRoleFromJSONTyped,
    ReplaceHomeHealthPractitionerAssignmentRoleToJSON,
} from './ReplaceHomeHealthPractitionerAssignmentRole';

/**
 *
 * @export
 * @interface ReplaceHomeHealthPractitionerAssignmentsRequest
 */
export interface ReplaceHomeHealthPractitionerAssignmentsRequest {
    /**
     *
     * @type {Array<ReplaceHomeHealthPractitionerAssignmentRole>}
     * @memberof ReplaceHomeHealthPractitionerAssignmentsRequest
     */
    roles: Array<ReplaceHomeHealthPractitionerAssignmentRole>;
}

/**
 * Check if a given object implements the ReplaceHomeHealthPractitionerAssignmentsRequest interface.
 */
export function instanceOfReplaceHomeHealthPractitionerAssignmentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roles" in value;

    return isInstance;
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestFromJSON(json: any): ReplaceHomeHealthPractitionerAssignmentsRequest {
    return ReplaceHomeHealthPractitionerAssignmentsRequestFromJSONTyped(json, false);
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceHomeHealthPractitionerAssignmentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'roles': ((json['roles'] as Array<any>).map(ReplaceHomeHealthPractitionerAssignmentRoleFromJSON)),
    };
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestToJSON(value?: ReplaceHomeHealthPractitionerAssignmentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'roles': ((value.roles as Array<any>).map(ReplaceHomeHealthPractitionerAssignmentRoleToJSON)),
    };
}
